
import './MessagePippipWidget.css';

function formatTime(time) {
    if (!time) return '';
    const date = new Date(time);
    return date.toLocaleString('vi-VN', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

export default function MessagePippip({ message, name = 'Pippip', time }) {
    return (
        <div className="messagewidget-pippip-container">
            <div className="messagewidget-pippip-row-grid">
                {/* Row 1: meta */}
                <div className="messagewidget-pippip-empty" />
                <div className="messagewidget-pippip-meta">
                    <span className="messagewidget-pippip-name">{name}</span>
                    {time && <span className="messagewidget-pippip-time">{formatTime(time)}</span>}
                </div>
                {/* Row 2: avatar + message */}
                <div className="messagewidget-pippip-avatar">
                    <img
                        src="/Image/logo-pippip.png"
                        alt="Pippip Logo"
                        className="messagewidget-pippip-logo"
                    />
                </div>
                <div className="messagewidget-pippip-bubble">
                    {message}
                </div>
            </div>
        </div>
    );
}
